import React from 'react';
import { STUD_PX } from '../../utils/legoLayout';
import './LegoBuilder.css';

interface LegoBaseplateGridProps {
  cols: number;
  rows: number;
}

export const LegoBaseplateGrid: React.FC<LegoBaseplateGridProps> = ({ cols, rows }) => {
  return (
    <div
      className='lego-baseplate-grid'
      style={{
        width: cols * STUD_PX,
        height: rows * STUD_PX,
        gridTemplateColumns: `repeat(${cols}, ${STUD_PX}px)`,
        gridTemplateRows: `repeat(${rows}, ${STUD_PX}px)`,
      }}
      aria-hidden
    >
      {Array.from({ length: rows * cols }, (_, index) => (
        <div key={index} className='grid-cell'>
          <div className='base-stud' />
        </div>
      ))}
    </div>
  );
};
